import React from "react";
import Avatar from "react-avatar";
import AuthenticatedImage from "./AuthenticatedImage";
import { PreviewZoom } from "./ImagePreview";

export const getImgUrl = (img) => {
  if (!img || img === "null" || img === "undefined") return null;
  if (img.startsWith("http")) return img;
  const base = (process.env.REACT_APP_BASE_URL || "http://localhost:5026/api/v1").split("/api/v1")[0];
  if (img.includes("/")) {
    const norm = img.startsWith("/") ? img : `/${img}`;
    return `${base}${norm.startsWith("/public") ? norm : `/public${norm}`}`;
  }
  return (process.env.REACT_APP_USER_DOCS_PATH || `${base}/public/users/docs/`) + img;
};

// preview (default on): a click on the picture opens it in the app's viewer; off where the avatar is itself
// a button (the header's account menu)
const UserProfile = ({ username, userImage, style, bgColor, preview = true }) => {
  const url = getImgUrl(userImage);

  const rawWidth  = style?.width  || "30";
  const rawHeight = style?.height || "30";
  const getCssValue = (val) =>
    typeof val === "string" && val.includes("%") ? val : `${String(val).replace("px", "")}px`;
  const width  = getCssValue(rawWidth);
  const height = getCssValue(rawHeight);

  const imageStyle = {
    ...style,
    width,
    height,
    minWidth: width,
    minHeight: height,
    objectFit: "cover",
    objectPosition: "center",
  };

  // Initials on a green avatar are black (site-wide rule for green backgrounds); other colours keep react-avatar's white
  const avatarBg = bgColor || "#0DDFAB";
  const isGreenBg = ["#0ddfab", "#00dfab", "#0bc698"].includes(String(avatarBg).toLowerCase());

  const avatarFallback = (
    <Avatar
      className="rounded"
      name={username}
      maxInitials={2}
      size={width.replace("px", "")}
      round="8px"
      textSizeRatio={3}
      color={avatarBg}
      fgColor={isGreenBg ? "#000" : undefined}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "600",
      }}
    />
  );

  if (!url) return avatarFallback;

  const picture = (
    <AuthenticatedImage
      src={url}
      fallback={avatarFallback}
      className="rounded"
      alt={username}
      style={imageStyle}
      width={width.replace("px", "")}
      height={height.replace("px", "")}
    />
  );
  return preview ? <PreviewZoom src={url} className="rounded">{picture}</PreviewZoom> : picture;
};

export default UserProfile;
